/* Package JSON Import will be here */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import {
    toggleLoginOtpVerificationModal,
    loginOtpValidate,
    resendLoginOtp
} from "reducers/sessionOtpVerification";
import OtpForm from "components/form/OtpForm";
/* Project Import will be here */

const LoginVerification = (props) => {
    const { sessionOtpVerification } = useSelector((state) => ({
        sessionOtpVerification: state.sessionOtpVerification
    }));

    const dispatch = useDispatch();

    const toggleOtpVerificationModal = (e) => {
        e.stopPropagation();
        dispatch(toggleLoginOtpVerificationModal(null, null, null));
    };

    const onSubmit = values => {
        return dispatch(loginOtpValidate(values.loginOtpInput));
    }

    const onResendOtp = () => {
        dispatch(resendLoginOtp(sessionOtpVerification.tempToken, sessionOtpVerification.tempMobileNo));
    }

    return (
        <React.Fragment>
            {/* OTP login confirmation modal */}
            {sessionOtpVerification.isShowVerificationModal &&
                <OtpForm
                    modalShow={sessionOtpVerification.isShowVerificationModal}
                    modalToggle={toggleOtpVerificationModal}
                    onSubmit={onSubmit}
                    onResendOtp={onResendOtp}
                />
            }
        </React.Fragment>
    );
};

export default LoginVerification;